import { useMemo } from 'react'

import Form from './Form'
import View from './View'

const TotalBudget: BudgetComponent = props => {
  const Component = useMemo(
    () => (props?.isForm ? Form : View),
    [props?.isForm]
  )
  return <Component {...props} />
}

export default TotalBudget
